const { logger } = require("../config/logger")

const loggerAPI = (req, res, next) => {
    try {
        if(req.body.nameValuePairs) {
            const body = req.body.nameValuePairs;

            const metadata = {
                httpEndpoint: body.api ? body.api : '',
                payload: body.frontendPayload ? body.frontendPayload : '',
                message: body.frontendErrorMsg ? body.frontendErrorMsg : 'Frontend Error', 
                stack: body.frontendError ? body.frontendError : '',
                frontend: true,
                backendResponse: body.backendResponse ? body.backendResponse : ''
            };

            logger.log({ level: 'error', ...metadata });

        } else {
            logger.log({ level: 'error', message: JSON.stringify(req.body) });
        }
        next();
    } catch (error) {
        logger.log({ level: 'error', message: error });
        next();
    }
}

module.exports = {
    loggerAPI
}